import { toast } from "react-toastify";
import { getApiBaseUrl } from '../utils/apiBaseUrl';

export interface PendingApiAccessRequest {
  id: number;
  userId: number;
  status: string;
  requestedAt: string;
  reviewedAt: string | null;
  reviewedBy: number | null;
  userName: string | null;
  email: string | null;
  phoneNumber: string | null;
}

export const getPendingApiAccessRequests = async (
  token: string,
  t: (key: string) => string
): Promise<PendingApiAccessRequest[]> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/GetPendingApiAccessRequests`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch pending API access requests");
    }

    const data: PendingApiAccessRequest[] = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};